// Google Maps "Share" links (maps.app.goo.gl, goo.gl/maps) and normal
// google.com/maps/place|dir links send X-Frame-Options and refuse to render
// in an <iframe> — silently, with no console error — which breaks the map
// everywhere that URL is used. Only a proper .../maps/embed?... URL (from
// Google's "Share > Embed a map") or a non-Google provider's embed URL is
// safe to frame.
const isEmbeddableMapUrl = (url) => {
  try {
    const { hostname, pathname } = new URL(url);
    if (/(^|\.)google\.[a-z.]+$/.test(hostname)) return pathname.startsWith('/maps/embed');
    if (hostname === 'goo.gl' || hostname === 'maps.app.goo.gl') return false;
    return true;
  } catch {
    return false;
  }
};

// Builds a Google Maps iframe src: prefers a manually-pasted embed URL
// (admin can paste a `https://www.google.com/maps/embed?pb=...` URL for finer
// control), otherwise falls back to a plain address-query embed that needs no
// API key, so a real map shows even when the admin never touched that field.
export const buildMapEmbedSrc = ({ mapEmbedUrl, address } = {}) => {
  if (mapEmbedUrl && isEmbeddableMapUrl(mapEmbedUrl)) return mapEmbedUrl;
  if (address) return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
  return null;
};

// Joins an address object (street/city/state/postcode/fullAddress) into a
// single query string, preferring a pre-composed fullAddress when present.
export const addressToQuery = (address) =>
  address?.fullAddress ||
  [address?.street, address?.city, address?.state, address?.postcode].filter(Boolean).join(', ') ||
  '';
